import React, { useState } from "react";
import "../styles/Resume.css";
import { 
  FaExternalLinkAlt, FaDownload, FaGithub,
  FaLaptopCode, FaTools, FaBriefcase, 
  FaGraduationCap, 
  FaCode, FaProjectDiagram, FaServer
} from "react-icons/fa";
import { portfolioProjects } from "../data/projects";

const Resume = () => {
  const [activeSection, setActiveSection] = useState("all");

  const filterContent = (section) => {
    setActiveSection(section);
  };

  return (
    <div className="resume-page">
      <div className="resume-paper-container">
        <div className="resume-header">
          <span className="resume-mono-label">03/</span>
          <h1>Resume</h1>
        </div>
        
        <div className="resume-actions">
          <a 
            href={`${process.env.PUBLIC_URL}/assets/resume-wc.pdf`} 
            target="_blank" 
            rel="noopener noreferrer"
            className="resume-view-button"
          >
            <FaExternalLinkAlt className="resume-button-icon" />
            <span>View PDF</span>
          </a>
          
          <a 
            href={`${process.env.PUBLIC_URL}/assets/resume-wc.pdf`} 
            download
            className="resume-download-button"
          >
            <FaDownload className="resume-button-icon" />
            <span>Download</span>
          </a>
        </div>
        
        <div className="resume-paper">
          <div className="resume-identity">
            <h2 className="resume-name">William Chapman</h2>
            <div className="resume-title">Full-Stack Developer</div>
          </div>
          
          <div className="resume-tabs">
            <button 
              className={`resume-tab ${activeSection === "all" ? "active" : ""}`}
              onClick={() => filterContent("all")}
            >
              All
            </button>
            <button 
              className={`resume-tab ${activeSection === "education" ? "active" : ""}`}
              onClick={() => filterContent("education")}
            >
              <FaGraduationCap className="tab-icon" /> Education
            </button>
            <button 
              className={`resume-tab ${activeSection === "skills" ? "active" : ""}`}
              onClick={() => filterContent("skills")}
            >
              <FaTools className="tab-icon" /> Skills
            </button>
            <button 
              className={`resume-tab ${activeSection === "experience" ? "active" : ""}`}
              onClick={() => filterContent("experience")}
            >
              <FaBriefcase className="tab-icon" /> Experience
            </button>
            <button 
              className={`resume-tab ${activeSection === "projects" ? "active" : ""}`}
              onClick={() => filterContent("projects")}
            >
              <FaProjectDiagram className="tab-icon" /> Projects
            </button>
          </div>
          
          {(activeSection === "all" || activeSection === "education") && (
            <div className="resume-section">
              <div className="resume-section-header">
                <div className="resume-section-marker">
                  <span className="resume-section-number">01</span>
                  <div className="resume-section-line"></div>
                </div>
                <h3>
                  <FaGraduationCap className="resume-section-icon" />
                  Education
                </h3>
              </div>
              
              <div className="resume-education-item">
                <div className="resume-education-details">
                  <div className="resume-institution">Western Governors University</div>
                  <div className="resume-degree">B.S in Software Engineering</div>
                  <div className="resume-graduation-date">Dec 2025</div>
                  <div className="resume-degree resume-degree-secondary">Beginning M.S in A.I Engineering</div>
                </div>
                
                <div className="resume-education-notes">
                  <div className="resume-courses-list">
                    <div className="resume-courses-title">Deep-Knowledge Courses</div>
                    <ul>
                      <li>Software Engineering / Back-End Development</li>
                      <li>Front-End Development / UI/UX Design</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          {(activeSection === "all" || activeSection === "skills") && (
            <div className="resume-section">
              <div className="resume-section-header">
                <div className="resume-section-marker">
                  <span className="resume-section-number">02</span>
                  <div className="resume-section-line"></div>
                </div>
                <h3>
                  <FaTools className="resume-section-icon" />
                  Skills
                </h3>
              </div>
              
              <div className="resume-skills-container resume-skills-text-mode">
                <div className="resume-skill-category">
                  <div className="resume-category-label">
                    <FaCode className="category-icon" /> Languages
                  </div>
                  <p className="resume-skill-line">
                    HTML, CSS, JavaScript, TypeScript, Python, Java, MySQL, MongoDB
                  </p>
                </div>
                
                <div className="resume-skill-category">
                  <div className="resume-category-label">
                    <FaServer className="category-icon" /> Frameworks and Libraries
                  </div>
                  <p className="resume-skill-line">
                    React, Node.js, Express.js, Spring
                  </p>
                </div>
                
                <div className="resume-skill-category">
                  <div className="resume-category-label">
                    <FaLaptopCode className="category-icon" /> Tools
                  </div>
                  <p className="resume-skill-line">
                    Figma, VSCode, Netlify, GitHub, GitLab, AWS Lambda, S3, Amazon RDS, Amazon Quicksight
                  </p>
                </div>
                
                <div className="resume-skill-category">
                  <div className="resume-category-label">
                    <FaTools className="category-icon" /> Soft Skills
                  </div>
                  <p className="resume-skill-line">
                    Problem-Solving, Communication, Time Management, Critical-Thinking, Collaboration, Agile
                  </p>
                </div>
              </div>
            </div>
          )}
          
          {(activeSection === "all" || activeSection === "experience") && (
            <div className="resume-section">
              <div className="resume-section-header">
                <div className="resume-section-marker">
                  <span className="resume-section-number">03</span>
                  <div className="resume-section-line"></div>
                </div>
                <h3>
                  <FaBriefcase className="resume-section-icon" />
                  Experience
                </h3>
              </div>
              
              <div className="resume-timeline">
                <div className="timeline-item">
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <div className="resume-experience-header">
                      <div className="resume-job-title">Lead Software Engineer Intern</div>
                      <div className="resume-company-name">Silver Spark Studios</div>
                      <div className="resume-job-date">May 2025 – Oct 2025</div>
                    </div>
                    
                    <div className="resume-job-description">
                      <ul>
                        <li>Led a team of developers in planning and executing full-stack web applications, defining project scope, timelines, and technical architecture</li>
                        <li>Integrated third-party APIs into web applications, enabling dynamic data-driven features and improving application functionality</li>
                        <li>Guided junior developers on project management best practices, including task breakdown, sprint planning, and workflow organization</li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="timeline-item">
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <div className="resume-experience-header">
                      <div className="resume-job-title">Freelance Full-Stack Developer</div>
                      <div className="resume-company-name">Will Chapman</div>
                      <div className="resume-job-date">Jan 2023 – May 2025</div>
                    </div>
                    
                    <div className="resume-job-description">
                      <ul>
                        <li>Developed an AI-powered color palette generator using modern APIs, enabling context-aware design recommendations and real-time user interaction</li>
                        <li>Improved UX and conversion-focused design for brands like Gymshark, Detroit Lions, and Alani Nu, including a streamlined 2-click purchase flow</li>
                        <li>Designed and developed a responsive React.js portfolio with dynamic UI components, API integrations, and interactive features to showcase projects and technical capabilities</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          
          {(activeSection === "all" || activeSection === "projects") && (
            <div className="resume-section">
              <div className="resume-section-header">
                <div className="resume-section-marker">
                  <span className="resume-section-number">04</span>
                  <div className="resume-section-line"></div>
                </div>
                <h3>
                  <FaProjectDiagram className="resume-section-icon" />
                  Projects
                </h3>
              </div>
              
              <div className="resume-projects-list">
                {portfolioProjects.map((project) => (
                  <article key={project.id} className="resume-project-block">
                    <div className="resume-project-media">
                      <img
                        src={`${process.env.PUBLIC_URL}${project.image}`}
                        alt={project.title}
                        loading="lazy"
                      />
                    </div>
                    <div className="resume-project-main">
                      <h4 className="resume-project-title">{project.title}</h4>
                      <div className="resume-project-tags" aria-label="Technologies">
                        {project.technologies.map((tech) => (
                          <span key={tech} className="resume-project-tag">
                            {tech}
                          </span>
                        ))}
                      </div>
                      <p className="resume-project-summary">{project.description}</p>
                      <div className="resume-project-links">
                        {project.liveLink && project.liveLink !== "#" && (
                          <a
                            href={project.liveLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="resume-project-link"
                          >
                            <FaExternalLinkAlt aria-hidden />
                            <span>Live</span>
                          </a>
                        )}
                        {project.githubLink && project.githubLink !== "#" && (
                          <a
                            href={project.githubLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="resume-project-link"
                          >
                            <FaGithub aria-hidden />
                            <span>Code</span>
                          </a>
                        )}
                      </div>
                    </div>
                  </article>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Resume;
